import { isEqual } from 'es-toolkit';
import { useLayoutEffect, useState } from 'react';

const POLL_INTERVAL = 100;

export type Rect = Omit<DOMRect, 'toJSON'>;

export function useElementRect<T extends HTMLElement>(element: T | null, pollInterval = POLL_INTERVAL): Rect | null {
  const [rect, setRect] = useState<Rect | null>(null);

  useLayoutEffect(() => {
    if (!element) {
      setRect(null);
      return;
    }

    const handleRect = () => {
      const newRect = element.getBoundingClientRect().toJSON() as Rect;
      setRect((previous) => (isEqual(previous, newRect) ? previous : newRect));
    };

    handleRect();

    const pollHandle = setInterval(handleRect, pollInterval);
    const resizeObserver = new ResizeObserver(handleRect);
    resizeObserver.observe(element);

    return () => {
      clearInterval(pollHandle);
      resizeObserver.disconnect();
    };
  }, [element, pollInterval]);

  return rect;
}
